export const SET_FACILITEITEN = 'SET_FACILITEITEN';
export const ADD_FACILITEITEN = 'ADD_FACILITEITEN';
export const FACILITEIT_ERROR = 'FACILITEIT_ERROR';
export const SET_FACILITEIT = 'SET_FACILITEIT'
export const SET_BESCHIKBAARHEID = 'SET_BESCHIKBAARHEID'
export const SET_RESERVERINGEN = 'SET_RESERVERINGEN'
export const SET_WEEK = 'SET_WEEK'

function handleResponse(response) {
  if (response.ok) {
    return response.json();

  } else {
    let error = new Error(response.statusText);
    error.response = response.statusText;
    throw error;
  }
}


export function set(results) {
  return {
    type: SET_FACILITEITEN,
    results
  }
}

export function setreserveringen(results) {
  return {
    type: SET_RESERVERINGEN,
    results
  }
}

export function setone(results) {
  return {
    type: SET_FACILITEIT,
    results
  }
}

export function setweek(results) {
  return {
    type: SET_WEEK,
    results
  }
}
export function add(results) {
  return {
    type: SET_FACILITEIT,
    results
  }
}
export function itemError(error) {
  return {
    type: FACILITEIT_ERROR,
    payload: error
  };
}
export function setbeschikbaarheid(results) {
  return {
    type: SET_BESCHIKBAARHEID,
    results
  }
}


export function savefaciliteiten(data) {
  return dispatch => {
    return fetch('/api/admin/faciliteiten', {
      method: 'post',
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem('token')
      }
    }).then(handleResponse).then(results => {
      dispatch(add(results));
      return true;
    }).catch((err) => {
      return dispatch(itemError('Er is een fout opgetreden bij het insert database'));
    });
  };
}


export function savebeschikbaarheid(data) {
  return dispatch => {
    return fetch('/api/admin/beschikbaarheid', {
      method: 'post',
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem('token')
      }
    }).then(handleResponse).then(results => {
      return  dispatch(results);
    }).catch((err) => {
      return dispatch(itemError('Er is een fout opgetreden bij het insert database'));
    });
  };
}

export function savereververing(data) {    
  return dispatch => {
    return fetch('/api/admin/reservering/', {
      method: 'post',
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem('token')
      }
    }).then(handleResponse).then(results => {
      return results;
    }).catch((err) => {
      console.log(err);
      
      return dispatch(itemError('Er is een fout opgetreden bij het insert database'));
    });
  };
}

export function saveweek(data) {
  return dispatch => {
    return fetch('/api/admin/week', {
      method: 'post',
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem('token')
      }
    }).then(handleResponse).then(results => {
      return  dispatch(setweek(results));
    }).catch((err) => {
      return dispatch(itemError('Er is een fout opgetreden bij het insert database'));
    });
  };
}

export function startweekvalues(data) {
  return dispatch => {
    return fetch('/api/admin/week/start/week', {
      method: 'post',
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem('token')
      }
    }).then(handleResponse).then(results => {
      return  dispatch(setweek(results));
    }).catch((err) => {
      return dispatch(itemError('Er is een fout opgetreden bij het insert database'));
    });
  };
}


export function setaanwezig(data) {
  return dispatch => {
    return fetch('/api/admin/reserveringen/aanwezig/', {
      method: 'post',
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem('token')
      }
    }).then(handleResponse).then(results => {
      return dispatch(true);
    }).catch((err) => {
      return dispatch(itemError('Er is een fout opgetreden bij het insert database'));
    });
  };
}

export function getweek(id, data) {
  return dispatch => {
    return fetch('/api/admin/week/'+id, {
      method: 'post',
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem('token')
      }
    }).then(handleResponse).then(results => {
      return dispatch(setweek(results.results));
    }).catch((err) => {
      return dispatch(itemError('Er is een fout opgetreden bij het insert database'));
    });
  };
}

export function updatefaciliteit(id, data) {
  return dispatch => {
    return fetch('/api/admin/faciliteiten/'+id, {
      method: 'put',
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem('token')
      }
    }).then(handleResponse).then(results => {
      dispatch(add(results));
      return true;
    }).catch((err) => {
      return dispatch(itemError('Er is een fout opgetreden bij het insert database'));
    });
  };
}
export function delfaciliteit(id) {
  return dispatch => {
    return fetch('/api/admin/faciliteiten/'+id, {
      method: 'delete',
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem('token')
      }
    }).then(handleResponse).then(results => {
      return true
    }).catch((err) => {
      return dispatch(itemError('Er is een fout opgetreden bij het insert database'));
    });
  };
}


export function getbeschikbaarheidweek(data) {
  return dispatch => {
    return fetch('/api/admin/beschikbaarheid/week', {
      method: 'post',
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem('token')
      }
    }).then(handleResponse).then(results => {
      return dispatch(setbeschikbaarheid(results.results));
    }).catch((err) => {
      return dispatch(itemError('Er is een fout opgetreden bij het insert database'));
    });
  };
}
export function getfaciliteit(id) {
  return dispatch => {
    return fetch('/api/admin/faciliteiten/'+id, {
      method: 'get',
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem('token')
      }
    }).then(handleResponse).then(results => {
      return dispatch(setone(results.results));
    }).catch((err) => {
      return dispatch(itemError('Er is een fout opgetreden bij het insert database'));
    });
  };
}

export function getbeschikbaarheid(data) {  
  return dispatch => {
    return fetch('/api/admin/beschikbaarheid/check/', {
      method: 'post',
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem('token')
      }
    }).then(handleResponse).then(results => {
      return dispatch(setbeschikbaarheid(results.results));
    }).catch((err) => {
      return dispatch(itemError('Er is een fout opgetreden bij het insert database'));
    });
  };
}

export function fetchfaciliteiten() {
  return dispatch => {
    return fetch('/api/admin/faciliteiten/', {
      method: 'get',
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem('token')
      }
    }).then(handleResponse).then(results => {
      return dispatch(set(results.results));
    }).catch((err) => {
      return dispatch(itemError('Er is een fout opgetreden bij het insert database'));
    });
  };
}

export function fetchreserveringen(data) {
  return dispatch => {
    return fetch('/api/admin/reserveringen', {
      method: 'post',
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem('token')
      }
    }).then(handleResponse).then(results => {
      return dispatch(setreserveringen(results.results));
    }).catch((err) => {
      return dispatch(itemError('Er is een fout opgetreden bij het insert database'));
    });
  };
}

export function deletereservering(id) {
  return dispatch => {
    return fetch('/api/admin/reservering/'+id, {
      method: 'delete',
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem('token')
      }
    }).then(handleResponse).then(results => {
      return dispatch(results.results);
    }).catch((err) => {
      return dispatch(itemError('Er is een fout opgetreden bij het insert database'));
    });
  };
}